import Pagination from './Pagination';
import './style/index';
export default Pagination;